import { isBeta } from 'shared/utils/env'

export const logAnalyticsEvents = (eventData: unknown) => {
  if (isBeta || process.env.NEXT_PUBLIC_LOG_ANALYTICS === 'true') {
    console.log('seoEvent', eventData)
  }
}
